declare global {
  interface Window {
    __SCRIBE_SUPPORT_SECURITY__?: { protectedDocument: boolean; framed: boolean };
  }
}

export function isSupportApprovalPath(path: string): boolean {
  try { path = decodeURIComponent(path); } catch { return true; }
  return /^\/agent-platform\/support-(connect|credit-approval|coordinator-connect)\/*$/i.test(path)
    || /^\/support\/request\/*$/i.test(path)
    || /^\/account\/(integrations-connect|operator-integrations)\/*$/i.test(path);
}

export function isSupportApprovalDocument(): boolean {
  return typeof window !== 'undefined' && window.__SCRIBE_SUPPORT_SECURITY__?.protectedDocument === true;
}

export function isSupportApprovalFramed(): boolean {
  try { return window.top !== window.self || window.__SCRIBE_SUPPORT_SECURITY__?.framed === true; }
  catch { return true; }
}

export function marketingAllowed(): boolean {
  return typeof window !== 'undefined' && !isSupportApprovalDocument()
    && !isSupportApprovalPath(window.location.pathname);
}
